import { useState } from 'react';
import { useTranslation } from 'react-i18next';

export const STATUS_OPTIONS = ['applied', 'interview', 'offer', 'rejected', 'withdrawn'];

export const EMPTY_FORM = {
    company_name: '',
    position: '',
    status: 'applied',
    applied_date: '',
    deadline: '',
    job_url: '',
    salary_range: '',
    job_description: '',
};

function ApplicationForm({ onSubmit, error }) {
    const { t } = useTranslation();
    const [form, setForm] = useState(EMPTY_FORM);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(form, () => setForm(EMPTY_FORM));
    };

    return (
        <div className="card">
            <h2>{t('internships.new_application')}</h2>
            {error && <div className="error-message">{error}</div>}
            <form onSubmit={handleSubmit}>
                <div className="form-row">
                    <div className="form-group">
                        <label>{t('internships.company')} *</label>
                        <input
                            type="text"
                            value={form.company_name}
                            onChange={e => setForm({ ...form, company_name: e.target.value })}
                            placeholder={t('internships.placeholders.company')}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <label>{t('internships.position')} *</label>
                        <input
                            type="text"
                            value={form.position}
                            onChange={e => setForm({ ...form, position: e.target.value })}
                            placeholder={t('internships.placeholders.position')}
                            required
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label>{t('internships.status')}</label>
                        <select
                            value={form.status}
                            onChange={e => setForm({ ...form, status: e.target.value })}
                        >
                            {STATUS_OPTIONS.map(s => (
                                <option key={s} value={s}>{t(`internships.${s}`)}</option>
                            ))}
                        </select>
                    </div>
                    <div className="form-group">
                        <label>{t('internships.applied_date')}</label>
                        <input
                            type="date"
                            value={form.applied_date}
                            onChange={e => setForm({ ...form, applied_date: e.target.value })}
                        />
                    </div>
                </div>

                <div className="form-row">
                    <div className="form-group">
                        <label>{t('internships.job_url')}</label>
                        <input
                            type="url"
                            value={form.job_url}
                            onChange={e => setForm({ ...form, job_url: e.target.value })}
                            placeholder={t('internships.placeholders.job_url')}
                        />
                    </div>
                    <div className="form-group">
                        <label>{t('internships.salary')}</label>
                        <input
                            type="text"
                            value={form.salary_range}
                            onChange={e => setForm({ ...form, salary_range: e.target.value })}
                            placeholder={t('internships.placeholders.salary')}
                        />
                    </div>
                </div>

                <div className="form-group">
                    <label>
                        {t('internships.job_description')}
                        <span className="field-hint"> {t('internships.paste_hint')}</span>
                    </label>
                    <textarea
                        value={form.job_description}
                        onChange={e => setForm({ ...form, job_description: e.target.value })}
                        placeholder={t('resume.paste_placeholder')}
                        rows={5}
                    />
                </div>

                <button type="submit" className="btn-primary">
                    {t('internships.save_application')}
                </button>
            </form>
        </div>
    );
}

export default ApplicationForm;